export default "__VITE_ASSET__wzh2Aj5T__"